export const isValidValue = (value) => value !== 'undefined' && !!value;
